import { useEffect, useState } from "react";
import { ArrowDown } from "lucide-react";

const hiddenCards = (root) =>
    root ? [...root.querySelectorAll("article")].filter((a) => a.getBoundingClientRect().top >= window.innerHeight) : [];

export const MoreBelow = ({ rootRef, watch, disabled }) => {
    const [count, setCount] = useState(0);
    const [atTop, setAtTop] = useState(true);

    useEffect(() => {
        const measure = () => {
            setCount(hiddenCards(rootRef.current).length);
            setAtTop(window.scrollY < 8);
        };
        measure();
        window.addEventListener("scroll", measure, { passive: true });
        window.addEventListener("resize", measure);
        return () => {
            window.removeEventListener("scroll", measure);
            window.removeEventListener("resize", measure);
        };
    }, [rootRef, watch]);

    if (disabled || !atTop || count === 0) return null;

    const label = `${count} more ${count === 1 ? "document" : "documents"}`;

    return (
        <button
            type="button"
            aria-label={`${label} below`}
            title={`${label} below`}
            onClick={() => hiddenCards(rootRef.current)[0]?.scrollIntoView({ behavior: "smooth", block: "nearest" })}
            className="fixed bottom-[24px] right-[26px] z-[50] hidden w-[44px] flex-col items-center justify-center gap-0.5 rounded-full bg-[#082e54] pt-2 pb-2 text-[#fff] shadow-modal lg:flex"
        >
            <ArrowDown className="h-4 w-4" aria-hidden="true" />
            <span className="text-xs font-bold">{count}</span>
        </button>
    );
};
